module.exports = __webpack_public_path__ + "img/icon-to-validate.37616934.svg";